function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.4375 5.17188L6.96875 4.98438C6.03125 4.58594 5 4.375 3.94531 4.375H3.125V12.625H3.94531C5.14062 12.625 6.3125 12.8359 7.4375 13.2344V5.17188ZM8.5625 13.2344C9.6875 12.8359 10.8594 12.625 12.0547 12.625H12.875V4.375H12.0547C11 4.375 9.99219 4.58594 9.03125 4.98438L8.5625 5.17188V13.2344ZM7.41406 3.95312L8 4.1875L8.58594 3.95312C9.6875 3.48438 10.8594 3.25 12.0547 3.25H12.875C13.5078 3.25 14 3.76562 14 4.375V12.625C14 13.2578 13.5078 13.75 12.875 13.75H12.0547C10.8594 13.75 9.6875 13.9844 8.58594 14.4531L8.28125 14.5703C8.09375 14.6406 7.90625 14.6406 7.71875 14.5703L7.41406 14.4531C6.3125 13.9844 5.14062 13.75 3.94531 13.75H3.125C2.51562 13.75 2 13.2578 2 12.625V4.375C2 3.76562 2.51562 3.25 3.125 3.25H3.94531C5.14062 3.25 6.3125 3.48438 7.41406 3.95312Z",
  fill: "currentColor"
});

function SvgTrainingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingIcon);
export default __webpack_public_path__ + "static/media/training-icon.997d3d23.svg";
export { ForwardRef as ReactComponent };